export default __webpack_public_path__ + "static/media/clock.e8ecf2d3.svg";